import React, {useState} from 'react';
import cn from 'classnames';

import Button from 'brandComponents/Button';
import Icon from 'brandComponents/Icon';

import {IPasswordFieldProps} from './IPasswordField';

// eslint-disable-next-line no-restricted-imports
import './PasswordField.scss';

const PasswordField = ({placeholder, meta, className = '', input, iconSize, id, ref}: IPasswordFieldProps) => {
	const [passwordType, setPasswordType] = useState('password');
	const isErrorShown = meta.touched && (meta.error || meta.submitError);

	const togglePassword = (e) => {
		e.preventDefault();

		if (passwordType === 'password') {
			setPasswordType('text');

			return;
		}

		setPasswordType('password');
	};

	return (
		<div className="password-input-block">
			<input
				id={id}
				{...input}
				ref={ref}
				placeholder={placeholder}
				type={passwordType}
				className={cn(className, {invalid: isErrorShown})}
			/>
			<div className="input-group-btn">
				<Button
					tabIndex={-1}
					classNames="show-hide-button"
					onClick={togglePassword}
				>
					<Icon
						name={passwordType === 'password' ? 'show' : 'hide'}
						width={iconSize?.width && iconSize.width}
						height={iconSize?.height && iconSize.height}
					/>
				</Button>
			</div>
		</div>
	);
};

export default PasswordField;
